import { Routes } from '@angular/router';
import { ResearchPortalMainComponent } from './research-portal-main/research-portal-main.component';
import { SectorsComponent } from './sectors/sectors.component';
import { AuthGuard } from '../../shared/auth-guard';
import { SectorValuationMetricsComponent } from './sector-valuation-metrics/sector-valuation-metrics.component';
import { StocksComponent } from './stocks/stocks.components';
import { StockOverviewComponent } from './stocks/stock-overview/stock-overview.component';
import { HistoricalDataComponent } from './stocks/historical-data/historical-data.component';
import { DisclaimerGuard } from './shared/disclaimer-guard';
import { MarketInsightsComponent } from '../portal-dashboard/market-insights/market-insights.component';
import { DscDashboardComponent } from '../dsc-dashboard/dsc-dashboard.component';
import { PortalDisclaimerGuard } from '../../shared/privilege-guard';

export const researchPortalRouting = [
  {
    path: 'research-portal',
    component: ResearchPortalMainComponent,
    canActivate: [AuthGuard, DisclaimerGuard],
    children: [
      {
        path: 'stocks',
        component: StocksComponent,
        children: [
          {
            path: 'overview',
            component: StockOverviewComponent,
          },
          {
            path: 'historical-data',
            component: HistoricalDataComponent,
          },
        ],
      },
      {
        path: 'sectors',
        component: SectorsComponent,
      },
      {
        path: 'sector-valuation-metrics',
        component: SectorValuationMetricsComponent,
      },
      {
        path: 'market-insights',
        component: MarketInsightsComponent,
      },
      {
        path: 'dsc-dashboard',
        component: DscDashboardComponent,
        canActivate: [PortalDisclaimerGuard],
      },
    ],
  },
];
